<template>
      <router-link :to="routeTo" class="flex justify-between px-4 py-4 notification cursor-pointer text-dark">
        <div class="flex items-start">
          <feather-icon :icon="icon" svgClasses="text-primary stroke-current mr-1 h-6 w-6"></feather-icon>
          <div class="mx-2">

            <small v-if="notification.type === 'assignment'">يوجد واجب جديد في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'assignment_confirmed'">اكتمل تصحيح الواجب في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'quiz'">يوجد إختبار جديد في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'quiz_confirmed'">اكتمل تصحيح الإختبار في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'quiz_time_updated'">لقد تم تعديل وقت إختبار في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'lecture'">تمت إضافة محاضرة جديدة في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'questions_bank'">تم إضافة نموذج اسئلة في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'student_approved_to_course'">تم الموافقة علي طلب تسجيلك في {{notification.data.body}}</small>

            <small v-else-if="notification.type === 'post'">
              لقد قام
              <span class="text-primary">{{notification.data.users[0]}}</span>
              <span class="text-primary" v-if="notification.data.users.length === 2"> و{{notification.data.users[1]}}</span>
              <span v-if="notification.data.users.length > 2"> و{{notification.data.users.length}} آخرون</span>
              بإنشاء نقاش جديد في {{notification.data.body}}
            </small>

            <small v-else-if="notification.type === 'comment'">لقد قام
              <span class="text-primary">{{notification.data.users[0]}}</span>
              <span class="text-primary" v-if="notification.data.users.length === 2"> و{{notification.data.users[1]}}</span>
              <span v-if="notification.data.users.length > 2"> و{{notification.data.users.length}} آخرون</span>
              بالتعليق علي النقاش:
              <span class="truncate block w-56">{{notification.data.body}}</span>
            </small>

            <small v-else-if="notification.type === 'student_requested_to_join'">
              يوجد
              <span v-if="notification.data.count > 2">{{notification.data.count}} طلبات </span>
              <span v-else-if="notification.data.count === 2">طلبان </span>
              <span v-else>طلب</span>
              تسجيل في {{notification.data.body}}
            </small>

          </div>
        </div>
        <small class="mt-1 whitespace-no-wrap">{{ notification.created_at | ago }}</small>
      </router-link>
</template>

<script>
    export default {
        name: 'NotificationItem',
        props: {
            notification: {
                type: Object,
                required: true
            },
        },
        computed: {
            icon() {
                switch (this.notification.type) {
                    case 'post' : return 'MessageSquareIcon'
                    case 'comment' : return 'MessageSquareIcon'
                    case 'assignment' : return 'FileTextIcon'
                    case 'assignment_confirmed' : return 'FileTextIcon'
                    case 'quiz' : return 'HelpCircleIcon'
                    case 'quiz_confirmed' : return 'HelpCircleIcon'
                    case 'lecture' : return 'LayersIcon'
                    case 'questions_bank' : return 'ArchiveIcon'
                    case 'student_approved_to_course' : return 'BookIcon'
                    case 'student_requested_to_join' : return 'BookIcon'
                    default : return 'BellIcon'
                }
            },
            routeTo() {
                switch (this.notification.type) {
                    case 'post' : return {name:'courseDiscussions', params: {course_id: this.notification.data.course_id}}
                    case 'comment' : return {name:'courseDiscussions', params: {course_id: this.notification.data.course_id}}
                    case 'assignment' : return {name:'courseAssignments', params: {course_id: this.notification.data.course_id}}
                    case 'assignment_confirmed' : return {name:'assignment', params: {course_id: this.notification.data.course_id, assignment_id: this.notification.to_id}}
                    case 'quiz' : return {name:'courseQuizzes', params: {course_id: this.notification.data.course_id}}
                    case 'quiz_time_updated' : return {name:'courseQuizzes', params: {course_id: this.notification.data.course_id}}
                    case 'quiz_confirmed' : return {name:'courseQuizResult', params: {course_id: this.notification.data.course_id, quiz_id: this.notification.to_id}}
                    case 'lecture' : return {name:'courseLecture', params: {course_id: this.notification.data.course_id, lecture_id: this.notification.to_id}}
                    case 'questions_bank' : return {name: 'courseQuestionBank', params: {course_id: this.notification.data.course_id, question_bank_id: this.notification.to_id}}
                    case 'student_approved_to_course' : return {name: 'courseHome', params: {course_id: this.notification.data.course_id}}
                    case 'student_requested_to_join' : return {name: 'courseStudents', params: {course_id: this.notification.data.course_id}}
                    default : return this.$route
                }
            },
        }
    }
</script>
